import { QueryTypeName } from './query-type';

export function isTFLIncompleteFiles(queryTypeName?: string): boolean {
    return queryTypeName === QueryTypeName.TFL_INCOMPLETE_FILES;
}
